/**
 * Modèle "Carrousel vedette site" partagé entre l'admin et le site (dupliqué
 * depuis demo-admin/lib/siteSliderShape.ts — repos séparés, pas de package
 * commun pour l'instant).
 *
 * 5 images max éditables via CRM, affichées sur la home dans le bloc animé
 * brixsa-parallax après "Le Lieu". Distinct de la galerie souvenirs Stories.
 */

export const SITE_SLIDER_MAX_IMAGES = 5

export interface SiteSliderImage {
  id: string
  url: string
  title?: string
  subtitle?: string
  badge?: string
}

export type EventSiteSliderShape = SiteSliderImage[]

function freshId(): string {
  return Math.random().toString(36).slice(2, 10) + Date.now().toString(36).slice(-4)
}

export function normalizeSiteSlider(raw: unknown): EventSiteSliderShape {
  if (raw == null) return []
  if (!Array.isArray(raw)) return []

  const items: SiteSliderImage[] = []
  for (const entry of raw) {
    if (typeof entry !== 'object' || entry === null) continue
    const r = entry as Record<string, unknown>
    const url = typeof r.url === 'string' ? r.url.trim() : ''
    if (!url) continue
    items.push({
      id: typeof r.id === 'string' && r.id ? r.id : freshId(),
      url,
      title: typeof r.title === 'string' && r.title.trim() ? r.title.trim() : undefined,
      subtitle: typeof r.subtitle === 'string' && r.subtitle.trim() ? r.subtitle.trim() : undefined,
      badge: typeof r.badge === 'string' && r.badge.trim() ? r.badge.trim() : undefined,
    })
    if (items.length >= SITE_SLIDER_MAX_IMAGES) break
  }
  return items
}
